import React from 'react';
import NewHeroSection from '../components/NewHeroSection';
import LogoReveal from '../components/LogoReveal';
import FilmsSection from '../components/FilmsSection';
import WhatIPMIConnects from '../components/WhatIPMIConnects';
import MemberBenefits from '../components/MemberBenefits';
import FoundationSpotlight from '../components/FoundationSpotlight';
import LegacyGratitude from '../components/LegacyGratitude';
import JoinNextChapter from '../components/JoinNextChapter';
import EmblemDivider from '../components/EmblemDivider';

const Home = () => {
  return (
    <div className="home-container">
      <NewHeroSection />
      {/* Cinematic centerpiece — the two anniversary films, top billing under the hero */}
      <FilmsSection />
      <div id="foundation">
        <FoundationSpotlight />
      </div>
      <EmblemDivider />
      <div id="legacy">
        <LegacyGratitude />
      </div>
      <div id="what-connects">
        <WhatIPMIConnects />
      </div>
      <div id="benefits">
        <MemberBenefits />
      </div>
      <EmblemDivider />
      {/* Archive: the original "Story Behind the Logo" */}
      <div id="logo-story">
        <LogoReveal />
      </div>
      <div id="join">
        <JoinNextChapter />
      </div>
    </div>
  );
};

export default Home;